import { isApiError } from '@shared/api/errors/errors';
import { readApiError } from '@shared/api/errors/read-api-error';

export type LoadErrorKind = 'totp' | 'forbidden' | 'session' | 'network' | 'server' | 'unknown';

/** Определяет причину сбоя загрузки по коду и статусу ответа API, а не по тексту сообщения. */
export const classifyLoadError = (error: unknown): LoadErrorKind => {
  if (!isApiError(error)) return 'unknown';
  if (readApiError(error)?.code === 'ADMIN_TOTP_REQUIRED') return 'totp';
  if (error.status === 401) return 'session';
  if (error.status === 403) return 'forbidden';
  if (error.status === undefined) return 'network';
  if (error.status >= 500) return 'server';
  return 'unknown';
};
